export default __webpack_public_path__ + "static/media/default_avatar.f8e162d6.svg";